module.exports = __webpack_public_path__ + "img/java.a382a40e.svg";